import { api, formatApiError } from './api';

export function pairKey(drugA, drugB) {
  return [drugA, drugB]
    .map((s) => s.trim().toLowerCase())
    .sort()
    .join('|');
}

export async function runInteractions() {
  try {
    const { data } = await api.post('/interactions/run');
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function checkOnAdd(name, rxcui) {
  try {
    const { data } = await api.post('/interactions/check-on-add', {
      name,
      rxcui: rxcui ?? null,
    });
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

export async function getSafetyScore() {
  try {
    const { data } = await api.get('/interactions/safety-score');
    return data;
  } catch (err) {
    throw new Error(formatApiError(err));
  }
}

// Cross-screen state via localStorage
const TOAST_KEY = 'hc.post_add_toast';
const SEVERE_BANNER_KEY = 'hc.pending_severe_banner';
const RUN_CACHE_KEY = 'hc.last_run_results';

export function stashPostAddToast(toast) {
  try { localStorage.setItem(TOAST_KEY, JSON.stringify(toast)); } catch {}
}

export function consumePostAddToast() {
  try {
    const raw = localStorage.getItem(TOAST_KEY);
    if (!raw) return null;
    localStorage.removeItem(TOAST_KEY);
    return JSON.parse(raw);
  } catch { return null; }
}

export function stashPendingSevere(banner) {
  try { localStorage.setItem(SEVERE_BANNER_KEY, JSON.stringify(banner)); } catch {}
}

export function readPendingSevere() {
  try {
    const raw = localStorage.getItem(SEVERE_BANNER_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch { return null; }
}

export function clearPendingSevere() {
  try { localStorage.removeItem(SEVERE_BANNER_KEY); } catch {}
}

export function cacheRunResults(results) {
  try { localStorage.setItem(RUN_CACHE_KEY, JSON.stringify(results)); } catch {}
}

export function readCachedRunResults() {
  try {
    const raw = localStorage.getItem(RUN_CACHE_KEY);
    if (!raw) return [];
    return JSON.parse(raw);
  } catch { return []; }
}
